
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.04799 0C12.4843 0 16.0942 3.50576 16.0942 7.81674C16.0942 9.16521 15.7326 10.4968 15.0466 11.6678C14.9348 11.8585 14.8142 12.0432 14.69 12.2219C14.6303 12.3064 14.5607 12.3824 14.4999 12.4645L19.5326 17.3574C20.1564 17.961 20.1552 18.9413 19.5326 19.5473C19.2219 19.8491 18.8131 20 18.4055 20C17.9967 20 17.5891 19.8491 17.2784 19.5473L12.1289 14.5422C11.981 14.6267 11.8344 14.71 11.6567 14.7993C10.5184 15.3558 9.30431 15.6359 8.04799 15.6359C3.61171 15.6359 -0.00069046 12.1277 -0.00069046 7.81674C-0.00069046 3.50697 3.61047 0 8.04799 0ZM8.04871 12.5318C8.803 12.5318 9.53617 12.3616 10.2109 12.032C10.3352 11.968 10.457 11.9064 10.5825 11.8316C11.1715 11.4803 11.6673 11.0203 12.06 10.4638C12.137 10.3564 12.2104 10.2441 12.2762 10.1318C12.6938 9.41716 12.9062 8.6373 12.9062 7.81156C12.9062 5.21 10.7266 3.09375 8.04871 3.09375C5.36954 3.09375 3.18993 5.21 3.18993 7.81156C3.18993 10.4131 5.3683 12.5318 8.04871 12.5318Z","fill":"#4F4F4F"}})])
          )
        }
      }
    